module.exports = __webpack_public_path__ + "img/img_email.787d43f9.svg";